import makeInitialState from './makeInitialState';
import orderBy from 'lodash/orderBy';

export function loadProjectSuccess(state, project) {
    state.project = project;
}

export function jumpToAbsoluteTime(state, absoluteTime) {
    state.requestedAbsoluteTime = absoluteTime;
}

export function updateCurrentVideoAbsoluteTime(state, absoluteTime) {
    state.currentVideoAbsoluteTime = absoluteTime;
}

export function jumpToClip(state, clipId) {
    state.requestedAbsoluteTime = state.clipRanges[clipId].start;
}

export function jumpToAndPlayClip({commit, dispatch }, clipId) {
    commit('jumpToClip', clipId);
    dispatch('resume');
}

export function setClipRanges(state) {
    const orderedClips = orderBy(state.project.clips, 'order', 'asc');
    let durationPointer = 0;
    let ranges = {};

    orderedClips.forEach(clip => {
        ranges[clip.id] = {};
        ranges[clip.id].start = durationPointer;

        const startTime = clip.start_time || 0;
        const endTime = clip.end_time || clip.video.duration;
        const duration = endTime - startTime;

        durationPointer = durationPointer + duration;
        
        ranges[clip.id].end = durationPointer;
    });

    state.clipRanges = ranges;
}

export function paused(state) {
    state.isPaused = true;
}

export function resumed(state) {
    state.isPaused = false;
    state.hasEverPlayed = true;
}

export function reset(state) {
    const newState = makeInitialState();

    Object.keys(newState).forEach(key => state[key] = newState[key]);
}

export function setFullScreen(state, fullScreen) {
    state.isFullScreen = fullScreen;
}

export function setVolume(state, volume) {
    state.volume = volume;
}

export function muted(state) {
    state.isMuted = true;
}

export function unmuted(state) {
    state.isMuted = false;
}

export function expandedAllClips(state) {
    state.expandedAllClips = true;
}

export function unexpandedAllClips(state) {
    state.expandedAllClips = false;
}